const NAME = "ORGANIZATIONAL_BENEFITS";

export default NAME;
